import { Record } from "immutable";

export type QuestionAggregationType = {
  averageMark?: number;
  marksTotal?: number;
};

export const defaultQuestionAggregation: QuestionAggregationType = {
  averageMark: undefined,
  marksTotal: undefined
};

export default class QuestionAggregation extends Record(
  defaultQuestionAggregation
) {}
